import { debounce } from 'debounce';

export default {
    data() {
        return {
            isLoadingPage: true,
            isSpinning: false,
        };
    },
    methods: {
        startSpinner: debounce(function spinner() {
            if (this.isLoadingPage) {
                this.isSpinning = true;
            }
        }, 225),
        pageloaded() {
            this.isLoadingPage = false;
        },
        reloadPage() {
            this.isLoadingPage = true;
            this.startSpinner();
        },
    },
    created() {
        this.startSpinner();
    },
};
